/**
 * @fileoverview Checkout module events.
 */

import { EVENT_PREFIX } from "../../core/events";

/**
 * Checkout events.
 */
export const CHECKOUT_EVENTS = {
  /** Create checkout flow */
  CREATE: `${EVENT_PREFIX}checkout.create`,
  /** Checkout response from host */
  RESPONSE: `${EVENT_PREFIX}checkout.response`,
  /** Get available addons for the app */
  GET_ADDONS: `${EVENT_PREFIX}checkout.getAddons`,
  /** Get addons response from host */
  GET_ADDONS_RESPONSE: `${EVENT_PREFIX}checkout.getAddons.response`,
  /** Reset checkout cache on host */
  RESET_CACHE: `${EVENT_PREFIX}checkout.resetCache`,
} as const;
